import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Title = styled.h1`
    ${FONTS.H2};

    @media(max-width: 680px) {
        ${FONTS.H4};
    }
`;
